import http from "@/http/aisea/axios";
const resource = "/vessel_report/enterprise/reports";

export default {
  search(params) {
    return http.get(`${resource}`, {
      params: params
    });
  },
  fetchReport(payload) {
    return http.get(`${resource}/${payload.vesselId}`);
  }
};
